export default "__VITE_ASSET__B0WvlSz2__"